import React from 'react';
import { Card } from 'react-bootstrap';
import FormAuth from './FormAuth';

const CardAuth = () => {
    return (
        <div className="auth-page">
            <div className="auth-card-wrapper">
                <Card className="auth-card">
                    <div className="auth-card-brand">
                        <div className="auth-logo-ring">
                            <img
                                src="logo-yarsi.png"
                                alt="RS Yarsi"
                                className="auth-logo-img"
                            />
                        </div>
                        <h1 className="auth-hospital-name">RS YARSI</h1>
                        <p className="auth-subtitle">Content Management System</p>
                    </div>

                    <Card.Body className="auth-card-body">
                        <FormAuth />
                    </Card.Body>

                    <div className="auth-footer">
                        &copy; {new Date().getFullYear()} Rumah Sakit YARSI &middot; All rights reserved
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default CardAuth;
